import { render, staticRenderFns } from "./detail_ujian.vue?vue&type=template&id=29eecc5c&scoped=true&"
import script from "./detail_ujian.vue?vue&type=script&lang=js&"
export * from "./detail_ujian.vue?vue&type=script&lang=js&"
import style0 from "./detail_ujian.vue?vue&type=style&index=0&id=29eecc5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eecc5c",
  null
  
)

export default component.exports